import {makeAutoObservable} from "mobx"
import {CustomerListItemDto} from "../../api/cms"
import {api, catchApi} from "../../api"

class CmsListStore {
    get items(): CustomerListItemDto[] {
        return this._items
    }

    set items(value: CustomerListItemDto[]) {
        this._items = value
    }

    get pages(): number {
        return this._pages
    }

    set pages(value: number) {
        this._pages = value
    }

    get page(): number {
        return this._page
    }

    set page(value: number) {
        this._page = value
    }

    get size(): number {
        return this._size
    }

    set size(value: number) {
        this._size = value
    }

    private _items: CustomerListItemDto[] = []
    private _pages: number = 0
    private _page: number = 0
    private _size: number = 25

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const response = await catchApi(async () => await api.cms.api.listCustomers({
            page: this.page - 1,
            size: this.size
        }))

        const responseData = response!!.data
        this.pages = responseData.totalPages || 0
        this.items = responseData.items || []
    }
}

const cmsListStore = new CmsListStore()

export {
    cmsListStore
}
